import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectivesModule } from '../directives/directives.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GeneralModule } from '../general/general.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MaterialModule } from '../../material.module';
import { MomentModule } from 'ngx-moment';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { BrowseAllTeamTopicsPane as BrowseAllTeamTopicsPaneComponent } from './browseAllTeamTopicsPane.component';
import { BrowseMyTopicsPane as BrowseMyTopicsPaneComponent } from './browseMyTopicsPane.component';
import { BrowseNewTopicsPane as BrowseNewTopicsPaneComponent } from './browseNewTopicsPane.component';
import { BrowseSearchPane as BrowseSearchPaneComponent } from './browseSearchPane.component';
import { BrowseRootComponent } from './browseRoot.component';
import { BrowseCategoryPaneComponent } from './browseCategoryPane.component';
import { SummaryModule } from '../summary/summary.module';
import { NavigationModule } from '../navigation/navigation.module';
import { BrowseAllCatalogTopicsPaneComponent } from './browseAllCatalogTopicsPane.component';
import { BrowseCatalogPane as BrowseCatalogPaneComponent } from './browseCatalogPane.component';
import { BrowseCatalogCategoryPane as BrowseCatalogCategoryPaneComponent } from './browseCatalogCategoryPane.component';
import { BrowseCatalogCategoryTopicsPane as BrowseCatalogCategoryTopicsPaneComponent } from './browseCatalogCategoryTopicsPane.component';
import { BrowseTeamPaneComponent } from './browseTeamPane.component';
import { BrowseAllMyTopicsPaneComponent } from './browseAllMyTopicsPane.component';
import { BrowseAllNewTopicsPaneComponent } from './browseAllNewTopicsPane.component';
import { TopicSummaryGridComponent } from './topicSummaryGrid.component';
import { GroupSummaryComponent } from './groupSummary.component';
import { BrowseGroupsPaneComponent } from './browseGroupsPane.component';
import { GroupAvatarComponent } from './groupAvatar.component';
import { BrowseGroupsListComponent } from './browsGroupsList.component';
import { BrowseGroupDetailsComponent } from './browseGroupDetails.component';
import { GroupMembershipButtonComponent } from './groupMembershipButton.component';
import { GroupMembersIndicatorComponent } from './groupMembersIndicator.component';
import { GroupsModule } from '../groups/groups.module';
import { InviteToGroupComponent } from './inviteToGroup.component';
import { BrowseGroupComponent } from './browseGroup.component';
import { JoinGroupComponent } from './joinGroup.component';
import { ReadingModule } from '../reading/reading.module';
import { BrowseFeaturedTopicsPane } from './browseFeaturedTopicsPane.component';
import { NonScrollingTopicSummaryGridComponent } from './nonScrollingTopicSummaryGrid.copy';
import { BrowseHomeComponent } from './browseHome.component';

@NgModule({
    imports: [
        CommonModule,
        DirectivesModule,
        FlexLayoutModule,
        FormsModule,
        GeneralModule,
        GroupsModule,
        ReactiveFormsModule,
        HttpClientModule,
        MaterialModule,
        MomentModule,
        NavigationModule,
        ReadingModule,
        RouterModule,
        InfiniteScrollModule,
        SummaryModule
    ],
    declarations: [
        BrowseAllCatalogTopicsPaneComponent,
        BrowseAllMyTopicsPaneComponent,
        BrowseAllNewTopicsPaneComponent,
        BrowseAllTeamTopicsPaneComponent,
        BrowseCatalogPaneComponent,
        BrowseCatalogCategoryPaneComponent,
        BrowseCatalogCategoryTopicsPaneComponent,
        BrowseFeaturedTopicsPane,
        BrowseGroupComponent,
        BrowseGroupDetailsComponent,
        BrowseGroupsPaneComponent,
        BrowseGroupsListComponent,
        BrowseHomeComponent,
        BrowseMyTopicsPaneComponent,
        BrowseNewTopicsPaneComponent,
        BrowseSearchPaneComponent,
        BrowseTeamPaneComponent,
        BrowseRootComponent,
        BrowseCategoryPaneComponent,
        GroupAvatarComponent,
        GroupSummaryComponent,
        GroupMembershipButtonComponent,
        GroupMembersIndicatorComponent,
        InviteToGroupComponent,
        JoinGroupComponent,
        NonScrollingTopicSummaryGridComponent,
        TopicSummaryGridComponent
    ],
    exports: [
        BrowseAllCatalogTopicsPaneComponent,
        BrowseAllMyTopicsPaneComponent,
        BrowseAllNewTopicsPaneComponent,
        BrowseAllTeamTopicsPaneComponent,
        BrowseCatalogPaneComponent,        
        BrowseCatalogCategoryPaneComponent,
        BrowseCatalogCategoryTopicsPaneComponent,
        BrowseGroupsPaneComponent,
        BrowseTeamPaneComponent,
        BrowseMyTopicsPaneComponent,
        BrowseNewTopicsPaneComponent,
        BrowseSearchPaneComponent,
        BrowseRootComponent,        
        BrowseCategoryPaneComponent
    ]
})
export class BrowseModule {
}